export default __webpack_public_path__ + "static/media/how_to_1.57994f65.png";